var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthnaOffBgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 357,
    height: 465,
    viewBox: "0 0 357 465",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 24C0 10.7452 10.7452 0 24 0H333C346.255 0 357 10.7452 357 24V287C357 300.255 346.255 311 333 311H258C230.386 311 208 333.386 208 361V381C208 400.33 192.33 416 173 416C153.67 416 138 400.33 138 381V345C138 326.222 122.778 311 104 311C85.2223 311 70 326.222 70 345V430C70 449.33 54.33 465 35 465C15.67 465 0 449.33 0 430V287V129V24Z",
    fill: "url(#paint0_linear_360_2727)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_360_2727",
    x1: 31.5327,
    y1: 77.3566,
    x2: 309.554,
    y2: 526.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.319327,
    stopColor: "#F84CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904445,
    stopColor: "#FFE600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthnaOffBgMobile);
export default __webpack_public_path__ + "static/media/ethna_off_bg_mobile.1fb40f4af089a7ecaa4ca810c9ff6612.svg";
export { ForwardRef as ReactComponent };